/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
window.Vue = Vue;

window.axios = require('axios');

// laravel's default bootstrap.js is no longer required
// also note that BootstrapVue is independent of jQuery
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)


/**
 * Vue router configuration
 */
import VueRouter from 'vue-router'
Vue.use(VueRouter)

/**
 * Vuex for storing user related data
 */
import store from './vuex';

const serverBasePath = document.getElementsByTagName('server-base-path')[0].getAttribute('content').replace(window.location.origin, '')

const routes = [
    /**
     * Common Routes
     */
    {
        path: serverBasePath + '/whoami',
        name: 'whoami',
        component: require('@frontend/pages/Whoami.vue').default,
    },
    {
        path: serverBasePath + '/',
        name: 'home',
        component: require('@frontend/pages/LandingPage.vue').default,
    },
    {
        path: serverBasePath + '/login',
        name: 'login',
        component: require('@frontend/pages/Authentication/Index.vue').default,
        props: { authLogin: 'login' }
    },
    {
        path: serverBasePath + '/verify-email',
        name: 'verify-email',
        component: require('@frontend/pages/VerifyEmail.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/verify-email/:token',
        name: 'email-verified',
        component: require('@frontend/pages/VerifyEmail.vue').default,
        // beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/register',
        name: 'register',
        component: require('@frontend/pages/Authentication/Index.vue').default,
        props: { authLogin: 'register' }
    },
    {
        path: serverBasePath + '/register/:token',
        name: 'register-invited-members',
        component: require('@frontend/pages/Authentication/Index.vue').default,
        props: { authLogin: 'register' }
    },
    // {
    //     path: serverBasePath + '/phone/verify/:id/:token',
    //     name: 'verified-phone',
    //     component: require('@frontend/pages/VerifyPhone.vue').default,
    //     beforeEnter: requireLogin,
    // },
    {
        path: serverBasePath + '/phone/verify',
        name: 'verify-phone',
        component: require('@frontend/pages/VerifyPhone.vue').default,
        beforeEnter: requireLogin,
    },

    {
        path: serverBasePath + '/account-under-review',
        name: 'account-under-review',
        component: require('@frontend/pages/AccountUnderReview.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/forgot-password',
        name: 'forgot-password',
        component: require('@frontend/pages/ForgotPassword.vue').default,
    },

    {
        path: serverBasePath + '/password/reset/:token',
        name: 'reset-password',
        component: require('@frontend/pages/ResetPassword.vue').default,
    },
    {
        path: serverBasePath + '/contractor/register/step-:step',
        name: 'register-contractor',
        component: require('./pages/contractor/register/Index.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/register/step-:step',
        name: 'register-manager',
        component: require('./pages/manager/register/Index.vue').default,
        beforeEnter: requireLogin,
    },
    /**
     * Manger Routes
     */
    // dashboard
    {

        path: serverBasePath + '/manager/dashboard',
        name: ManagerRouteNames.dashboard,
        component: require('./pages/manager/Dashboard.vue').default,
        beforeEnter: requireLogin,
    },
    // quote
    {
        path: serverBasePath + '/manager/quotes',
        name: ManagerRouteNames.quote,
        component: require('./pages/manager/quote/Index.vue').default,
        beforeEnter: requireLogin,
        props: route => ({ filterStatus: route.query.filterStatus ? route.query.filterStatus : 'open' })
    },
    {
        path: serverBasePath + '/manager/quote/:id/edit/:step',
        name: ManagerRouteNames.quoteEdit,
        component: require('./pages/manager/quote/edit/Index.vue').default,
        beforeEnter: requireLogin,
        props: route => ({ selected_contractors_id: route.query.selected_contractors_id }),
    },
    {
        path: serverBasePath + '/manager/quote/:id/view',
        name: ManagerRouteNames.quoteView,
        component: require('./pages/manager/quote/view/Index.vue').default,
        beforeEnter: requireLogin,
        props: true,
    },
    //  strata plan
    {
        path: serverBasePath + '/manager/strata-plan',
        name: ManagerRouteNames.strataPlan,
        component: require('./pages/manager/strata-plan/Index.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/strata-plan/:id/view',
        name: ManagerRouteNames.strataPlanView,
        component: require('./pages/manager/strata-plan/view/Index.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/strata-plan/:id/edit/:step',
        name: ManagerRouteNames.strataPLanEdit,
        component: require('./pages/manager/strata-plan/edit/Index.vue').default,
        beforeEnter: requireLogin,
    },
    // work order
    {
        path: serverBasePath + '/manager/workorder',
        name: ManagerRouteNames.workOrder,
        component: require('./pages/manager/quote/Index.vue').default,
        beforeEnter: requireLogin,
        props: route => ({ filterStatus: route.query.filterStatus ? route.query.filterStatus : 'open', workOrder: 'work-order' })
    },
    {
        path: serverBasePath + '/manager/workorder/:id/edit/:step',
        name: ManagerRouteNames.workOrderEdit,
        component: require('./pages/manager/quote/edit/Index.vue').default,
        beforeEnter: requireLogin,
        props: route => ({ selected_contractors_id: route.query.selected_contractors_id, workOrder: 'work-order' }),
    },
    {
        path: serverBasePath + '/manager/workorder/:id/view',
        name: ManagerRouteNames.workOrderView,
        component: require('./pages/manager/quote/view/Index.vue').default,
        beforeEnter: requireLogin,
        props: { workOrder: 'work-order' },
    },
    // contact
    {
        path: serverBasePath + '/manager/contacts/contractors',
        name: ManagerRouteNames.contactContractors,
        component: require('./pages/manager/contacts/Contractors/index.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/contacts/contractors/:id',
        name: ManagerRouteNames.contactContractorsView,
        component: require('./pages/manager/contacts/Contractors/view/Index.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/contacts/building-manager',
        name: ManagerRouteNames.contactBuildingManagers,
        component: require('./pages/manager/contacts/BuildingManagers').default,
        beforeEnter: requireLogin,
    },

    // user-settings
    {
        path: serverBasePath + '/manager/manage/addmember',
        name: ManagerRouteNames.addMembers,
        component: require('./pages/manager/manage/AddMember.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/manage/businessdetails',
        name: ManagerRouteNames.businessDetails,
        component: require('./pages/manager/manage/BusinessDetails.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/manage/teammembers',
        name: ManagerRouteNames.teamMembers,
        component: require('./pages/manager/manage/TeamMembers.vue').default,
        beforeEnter: requireLogin,
    },

    /**
     * Contractor Routes
     */
    // dashboard
    {
        path: serverBasePath + '/contractor/dashboard',
        name: ContractorRouteNames.dashboard,
        component: require('./pages/contractor/Dashboard.vue').default,
        beforeEnter: requireLogin,
    },
    // work order
    {
        path: serverBasePath + '/contractor/workorder',
        name: ContractorRouteNames.workOrder,
        component: require('./pages/contractor/quote/Index.vue').default,
        beforeEnter: requireLogin,
        props: route => ({ workOrder: 'work-order' }),
    },
    {
        path: serverBasePath + '/contractor/workorder/:id/view',
        name: ContractorRouteNames.workOrderView,
        component: require('./pages/contractor/quote/view/Index.vue').default,
        beforeEnter: requireLogin,
        props: { workOrder: 'work-order' },
    },
    // quote
    {
        path: serverBasePath + '/contractor/quotes',
        name: ContractorRouteNames.quote,
        component: require('./pages/contractor/quote/Index.vue').default,
        beforeEnter: requireLogin,
        props: route => ({ quoteType: route.query.quoteType == 'public-quotes' ? route.query.quoteType : 'my-quotes' }),
    },
    {
        path: serverBasePath + '/contractor/quote/:id/view',
        name: ContractorRouteNames.quoteView,
        component: require('./pages/contractor/quote/view/Index.vue').default,
        beforeEnter: requireLogin,
    },
    // contacts
    {
        path: serverBasePath + '/manager/contacts/my-contacts',
        name: ContractorRouteNames.contacts,
        component: require('./pages/manager/contacts/Mycontacts/Index.vue').default,
        beforeEnter: requireLogin,
    },
    // compliance
    {
        path: serverBasePath + '/contractor/compliance',
        name: ContractorRouteNames.compliance,
        component: require('./pages/contractor/Compliance/Index.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/contractor/compliance/:subPage',
        name: ContractorRouteNames.complianceSubPage,
        component: require('./pages/contractor/Compliance/Index.vue').default,
        beforeEnter: requireLogin,
        props: true,
    },


    // TODO
    //-----------------------------------------------------------------
    {
        path: serverBasePath + '/contractor/notifications',
        name: 'contractor-notifications',
        component: require('./pages/contractor/Notification.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/notifications',
        name: 'manager-notifications',
        component: require('./pages/manager/Notification.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/privacy-policy',
        name: 'privacy-policy',
        component: require('@frontend/pages/PrivacyPolicy.vue').default,

    },
    {
        path: serverBasePath + '/termsof-use',
        name: 'termsof-use',
        component: require('@frontend/pages/TermsofUse.vue').default,

    },
    {
        path: serverBasePath + '/contractor/manage/addmember',
        name: 'contractor-add-members',
        component: require('./pages/contractor/manage/AddMember.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/contractor/manage/businessdetails',
        name: 'contractor-business-details',
        component: require('./pages/contractor/manage/BusinessDetails.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/contractor/manage/teammembers',
        name: 'contractor-team-members',
        component: require('./pages/contractor/manage/TeamMembers.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/contractor/manage/documents',
        name: 'contractor-documents',
        component: require('./pages/contractor/manage/documents.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/contractor/profile/editprofile',
        name: 'edit-contractor-profile',
        component: require('./pages/contractor/profile/EditProfile.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/contractor/profile/updatepassword',
        name: 'edit-contractor-password',
        component: require('./pages/contractor/profile/UpdatePassword.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/profile/editprofile',
        name: 'edit-manager-profile',
        component: require('./pages/manager/profile/EditProfile.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: serverBasePath + '/manager/profile/updatepassword',
        name: 'edit-manager-password',
        component: require('./pages/manager/profile/UpdatePassword.vue').default,
        beforeEnter: requireLogin,
    },
    {
        path: '*',
        component: require('@frontend/pages/PageNotFound.vue').default,
    }
]

//Mixins
function requireLogin(to, from, next) {

    var userToken = sessionStorage.getItem('authenticatedUserToken');
    if (store.state.isUserAuthenticated) {
        if(store.state.authenticatedUserData.user.remember_token == userToken){
            next(true);
        }
    } else {
        next({
            //Here we can use user login name
            name: 'whoami',
            query: { redirectFrom: to.fullPath }
        })
    }
}

const router = new VueRouter({
    mode: 'history',
    routes
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('loader-component', require('./pages/includes/LoaderComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Swal from 'sweetalert2'
import _ from 'lodash'

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore, collection, addDoc } from "firebase/firestore"
import { getStorage } from "firebase/storage";
import {ContractorRouteNames, ManagerRouteNames} from "./routeNames";

const firebaseConfig = {
    apiKey: "AIzaSyCdSQytTAsZgY2g-9LEFvsTAv88i_EZ3nU",
    authDomain: "strata-310806.firebaseapp.com",
    projectId: "strata-310806",
    storageBucket: "strata-310806.appspot.com",
    messagingSenderId: "241606855058",
    appId: "1:241606855058:web:c8b6fff469c29d34e6994b",
    measurementId: "G-DZLFH72LF9"
};

//Initializing Fire base
var firebaseApp = initializeApp(firebaseConfig);

//For Cloud Messaging
const messaging = getMessaging();
onMessage(messaging, (payload) => {                             //When retrieving cloud messaging
    // console.log('Message received. ', payload);
});


//For Chatting
const fireStore = getFirestore();

//For Storage in firebase
const storage = getStorage(firebaseApp);

const app = new Vue({
    el: '#app',
    router,
    store,
    data: {
        bsLoader: false,
        loading: false,
        serverBasePath: serverBasePath,
        messaging: messaging,
        fireStore: fireStore,
        storage: storage,
        loggedInUserToken: ""
    },
    beforeCreate: function () {
        window.axios.defaults.baseURL = document.getElementsByTagName('server-base-path')[0].getAttribute('content');
        window.axios.defaults.withCredentials = false;
        window.axios.defaults.headers.common['Accept'] = 'application/json';
        window.axios.interceptors.request.use((request) => {
            if (_.has(request.headers, 'Load-Bs-Loader')) {
                // this.bsLoader = true
            }
            return request
        }, (error) => {
            if (!_.has(request.headers, 'Load-Bs-Loader')) {
                this.bsLoader = false
            }
            return Promise.reject(error)
        })
        window.axios.interceptors.response.use((response) => {
            if (_.has(response.headers, 'Load-Bs-Loader')) {
                this.bsLoader = false
            }
            return response
        }, (error) => {
            if (!_.has(error.response.headers, 'Load-Bs-Loader')) {
                this.bsLoader = false
            }
            switch (error.response.status) {
                case 401:
                    this.$router.push({ name: 'login' })
                    break

                case 419:
                    Swal.fire({
                        text: 'This page has expired! Would you like to refresh it?',
                        icon: 'warning',
                        showCancelButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.reload();
                        }
                    });
                    break;

                case 422:
                    if (_.has(error.response.headers, ' X-Show-Valid-Excpns')) {
                        Swal.fire({
                            text: Object.values(error.response.data.errors).reduce((a, b) => a.concat(b), []),
                            icon: "warning",
                            confirmButtonText: "Ok"
                        })
                    }
                    break

                default:
                    Swal.fire({
                        // title: error.response.status + " Error!",
                        text: error.response.data.message,
                        icon: "error",
                        confirmButtonText: "Ok"
                    })
                    break
            }
            return Promise.reject(error)
        });
    },
    methods: {
         whoami() {
            axios.post("whoami").then(response => {
                if (response.data && response.data.has_auth) {
                    if (response.data.force_redirect) {
                        // use  r for super admin panel
                        window.location.href = response.data.force_redirect;
                        return;
                    }

                    sessionStorage.setItem('authenticatedUserToken', response.data.vuex_data.user.remember_token);

                    // sessionStorage.setItem('authenticatedUserToken','user');
                    // this.loggedInUserRole = 'user';

                    this.$store.commit(
                        "setUserLoggedIn",
                        response.data.vuex_data
                    );
                window.axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.token;
                    if (
                        !response.data.vuex_data.user.phone_verified_at &&
                        response.data.vuex_data.role == "contractor" &&
                        response.data.vuex_data.invited_user == false
                    ) {
                        // checking if phone is verified
                        this.$router.push({
                            name: "verify-phone"
                        });
                    } else if (
                        !response.data.vuex_data.user.email_verified_at
                    ) {
                        // checking if email is verified
                        if (
                            this.$route.query.redirectFrom &&
                            this.$route.query.redirectFrom.indexOf(
                                "/verify-email/"
                            ) >= 0
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "verify-email"
                            });
                        }
                    } else if (response.data.vuex_data.role == "manager") {
                        // handling incomplete registration of manager
                        if (
                            !response.data.vuex_data.business &&
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 1}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "completed" &&
                            this.$route.query.redirectFrom &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "manager-dashboard"
                            });
                        }
                    } else if (response.data.vuex_data.role == "contractor") {
                        // handling incomplete registration of contractor
                        if (
                            !response.data.vuex_data.business &&
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 1}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "completed" &&
                            this.$route.query.redirectFrom &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "contractor-dashboard"
                            });
                        }
                    }
                }
                this.$data.bsLoader = false;
            });
        },
    }
});
